import styled from 'styled-components'

export const StyledPoint = styled.div(
    ({theme: {palette}}) => `
        width: 4px;
        height: 4px;
        background-color: ${palette.neutral[950]};
        border-radius: 100%;
    `
)
